<!--
 * @Author: your name
 * @Date: 2021-06-01 10:29:25
 * @LastEditTime: 2025-07-21 15:28:32
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\MediaItem.vue
-->
<template>
  <div class="media-item">
    <div class="media-img">
      <img class="m-img" :src="media.ref_thumb_url" style="object-fit: contain;" alt />
      <span class="m-time">{{ media.type == 1 ? msFormatting(media.ref_time) : "" }}</span>
    </div>
    <div class="media-title ellipsis-1" :title="media.ref_name">{{ media.name }}</div>
  </div>
</template>

<script>
import { msFormatting } from "@/assets/scripts/dateFormatting.js";
export default {
  name: 'MediaItem',
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      msFormatting: msFormatting,
    }
  },
  mounted() {
  },
  methods: {
    timeFormatting(time) {
      let ms = parseInt(time);
      let H = Math.floor(ms / 1000 / 60 / 60);
      let M = Math.floor(ms / 1000 / 60) % 60;
      let S = Math.ceil(ms / 1000) % 60;
      // let MS = ms % 1000;
      // return `${this.formatting(H)}:${this.formatting(M)}:${this.formatting(S)}:${this.formatting(MS, 3)}`;
      return `${this.formatting(H)}:${this.formatting(M)}:${this.formatting(S)}`;
    },
    formatting(time, len = 2) {
      let strTime = time + '';
      while (strTime.length < len) {
        strTime = '0' + strTime
      }
      return strTime;
    }
  }
}
</script>

<style lang="scss" scoped>
.media-item {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;

  .media-img {
    width: 100%;
    height: calc(100% - 16px);
    position: relative;

    .m-img {
      width: 100%;
      height: 100%;
      pointer-events: none;
      background: #F4F4F5;
    }

    .m-time {
      position: absolute;
      right: 0px;
      bottom: 0px;
      color: #ccc;
    }
  }

  .media-title {
    width: calc(100% - 8px);
    height: 16px;
    line-height: 16px;
    background-color: #eefbff;
    font-size: 14px;
    padding: 0px 4px;
  }
}
</style>